import { Button, type ButtonVariant } from "@ferrivia/ui";
import { useTranslation } from "@ferrivia/i18n";
import { useAppContext } from "../../app/useAppContext";

/** The pre-appointment screener's trigger.
 *
 * Opens the full-screen questionnaire overlay `AppShell` owns
 * (`../../questionnaire/QuestionnaireOverlay`) rather than a sheet of its
 * own — the overlay owns the consent gate, the questions, and the submit
 * lifecycle from here on. This component is left as the trigger, not folded
 * into `InfusionSteps` directly, because a future second entry point
 * (the hub-and-section plan's home resume block, a later phase of this
 * stack) reuses it.
 */
export function ScreenerSheet({
  onOpen,
  resumable,
  variant = "primary",
}: {
  /** The caller's own analytics — each entry point names its click in its
      own event rather than this trigger hardcoding one. */
  onOpen: () => void;
  resumable: boolean;
  /** Which weight the trigger carries. The infusion steps card keeps one
      primary control across its three steps, so a screener that is not the
      client's next move asks for a quieter button than one that is. */
  variant?: ButtonVariant;
}) {
  const { t } = useTranslation("client");
  const { openQuestionnaire } = useAppContext();

  function handleClick() {
    onOpen();
    openQuestionnaire();
  }

  return (
    <Button variant={variant} onClick={handleClick}>
      {resumable ? t("screener.resumeCta", "Jatka esitietoja") : t("screener.cta", "Täytä esitiedot")}
    </Button>
  );
}
